<template>
  <!-- eslint-disable max-len -->
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background" @click="close"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">使用者條款</p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="content">
感謝您使用丹科智慧平台有限公司(以下稱本公司)提供及管理之Line牙醫小幫手應用程式(以下稱本系統)。本條款構成您與本公司間的合法協議，用於規範您對於本應用程式之存取及使用。請詳細閱讀本條款內容，當您完成Dent&Co網站之會員註冊手續或開始使用本系統服務時，即表示您了解並同意受本條款之約束。您瞭解本條款之內容可能不定期修改，如您於本條款條款修訂公告後，仍繼續存取或使用本應用程式，即表示您接受並同意修訂之條款。如您不同意修訂條款，請您立即停止或刪除已下載之本應用程式。

<h4>使用者資格</h4>1. 您必須年滿 20 歲，才能使用 本應用程式及本應用程式所提供之服務(以下稱本服務)。您使用本應用程式，即表示您保證您已年滿 20 歲。如您已滿 20 歲但應受父母監護，請與父母或監護人一同檢視本條款，以確定您與您的父母或監護人瞭解並同意條款內容。您應負責確定在使用本應用程式時提供完整且正確之資訊，以存取服務之完整功能。
2. 如您在使用本應用程式時，有需要提供您的相關資訊時，您應提供最即時、完整且正確的資訊。您在使用本應用程式時所提供的相關資訊，本公司都視為是您個人或您依法或經合法授權(在您為第三方進行掛號時)所提供之資訊，且您應為您所提供之資訊之正確性及完整性負責，本公司不就因您所提供之資訊或因您所提供之資訊不完整或不正確所生之結果負責。
3. 您在使用本應用程式時，會利用您註冊之LINE帳號。請妥善使用並保管您的帳號，以免遭到第三人的不當使用。使用您的帳號所進行之一切行為均視為您本人之行為，由您自行負責。

<h4>本服務內容</h4>4. 本應用程式是用於協助您管理您（包括您依法有權或經授權為其行使權利義務之親友）的掛號資訊，包括看診項目、約診時間、約診提醒、約診後之衛教及評價回饋搜集等，您也可以透過本應用程式為您依法有權或經其授權之家人進行掛號 (與其他透過本應用程式所提供的服務和資訊，以下統稱「內容」)。本應用程式可能提供保健資訊或疾病說明內容，您了解本應用程式所提供之衛教資訊或內容、約診資訊等僅做為參考使用，並非提供健康或醫療服務，不能取代專業醫療建議。如需關於健康或醫療之詳細資訊，請諮詢醫師。若是醫療緊急情況，應馬上撥打119或當地緊急救護電話送醫急救。本應用程式以及您使用內容所接收之所有資訊將依循本公司隱私權政策。

<h4>個人資料收集及利用告知事項</h4>5. 除法令要求或合於法令規範或經您另以書面同意外，於任何本公司所提供之服務內，我們不會向任何第三方揭露任何直接關於您個人識別之資訊。惟本公司就本應用程式及本服務之管理，委託資訊廠商蒐集、處理與利用您個人識別之資訊者(包括使用第三方雲端服務儲存和處理您的個人資料)，不在此限。
6. 您所提供之個人資料，僅作為協助您個人管理您的約診資訊使用，為促進及維護您的健康，本公司將依您的需求，隨時以APP、手機簡訊或社群網路等通訊媒體提供相關就診服務、預防保健等相關訊息；您在此同意，本公司為滿足您個人對於健康促進之深層需求，將對您所提供經過代碼、匿名、隱藏部分資料及其他適切之方式處理而無從識別您個人身分之資料進行統計或加值分析、及透過本程式回饋提供您健康管理意見或衛教資訊等。
7. 為提供本應用程式之相關服務，本應用程式會收集您的部分個人資料，例如足以辨識您個人的資訊(例如您的姓名、電話、LINE帳號、身分證字號等)、個人描述(例如性別、出生年月日)、身體描述(例如身高、體重等)、健康紀錄(例如症狀描述、醫療報告、治療與診斷紀錄、檢驗結果等)。
8. 本公司透過本應用程式或服務所收集的您的個人資訊，其利用期間自您開始使用本應用程式之時起至停止服務之日止。本應用程式的使用地區為台灣地區(包括台灣本島、澎湖、金門及馬祖)。
9. 您得對本公司請求查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用及請求刪除使用者個人資料。若欲行使前述權利，可與本公司聯繫。請注意若您拒絕提供使用本服務所需必要之個人資料，則無法使用本服務。
10. 當您使用本應用程式時，輸入非您本人的個人資料，例如幫您的親友掛號而輸入親友之個人資料(例如身分證字號、出生年月日等)，除非法令另有規定或您是該第三人之法定監護人，您應自行以適當方式告知該第三人本條款的相關內容，使其知悉並且取得該第三人之同意。
11. 本應用程式及其服務處理個人資料過程中，將遵守相關流程與內部作業規範，並依據資訊安全之要求，進行必要之人員控管。
12. 您瀏覽使用本應用程式時，伺服器將會視使用的服務內容，自動記錄相關點選紀錄。其中可能包括使用者連線使用的IP位址、使用時間、瀏覽、使用紀錄等，做為提供相關服務之依據。除有本條款規定委託廠商蒐集、處理或利用使用者的個人資料之情形外，此記錄僅限於內部應用，絕不揭露給第三方。

<h4>授權</h4>13. 在本條款有效期間內，且在您完全遵守本條款所有條款與條件之前提下，本公司同意以目的碼形式授予您，個人的、不可轉讓且非專屬的權利，以供您在您個人擁有的行動裝置上基於非商業用途安裝及使用本應用程式，並得以檢視所收到之通知。
14. 本公司所授予您的權利，係以您遵守下列限制為條件。您不得：
a. 規避本應用程式中的任何技術限制；使用本應用程式或結合任何用於規避技術限制之裝置、程式或服務，企圖規避或破壞用於控制或存取內容或權限之技術措施；
b. 對本應用程式進行還原工程、解編、破解、反向組譯，或以其他方式試圖存取本應用程式之原始碼，惟相關法律明文許可或禁止此種限制者，不在此限；
c. 發表、出租、出借或再授權本應用程式或內容；
d. 散佈、移轉、揭露或以其他方式將本應用程式或內容提供予任何第三人；
e. 修改本應用程式或內容之全部或一部，或以此創作任何衍生著作；
f. 移除任何本應用程式或內容或其副本上的所有權通知或標示；
g. 將本應用程式或內容用於營利目的；
h. 使用本應用程式或內容侵害 本公司、其關係企業或任何第三人之權利，或以任何違反相關法律之方式使用本應用程式或內容；

<h4>服務變更或停止</h4>15. 一旦您違反本條款之任何條款和條件，本條款將自動終止。若本條款終止，您必須立即銷毀或停用本應用程式及內容之所有副本，惟本條款之下列條款將繼續有效：第 16 至 23 條。
16. 本公司保留不經通知隨時修改或暫時或永久停止提供本服務全部或其一部分之權利。對於您或是任何第三方，本公司就本服務之任何修改、暫停或停止提供不負任何責任。
17. 本公司將盡最大努力維護本應用程式的正常運作以及資料安全。本應用程式有可能出現中斷或故障等等的情況，您於使用本應用程式時宜自行採取防護措施，如因此造成您使用上的不便、資料的喪失、錯誤、遭人篡改或其他經濟上損失情形，本公司對您因為使用或無法使用本應用程式或其服務而造成的損害，不負任何賠償責任。

<h4>通知</h4>18. 本公司將會不定時發送自動通知。例如，當您於本系統之帳戶有任何異動時，我們也許會寄發通知給您。某些的通知是允許您手動設定、取消或重新啟動的。本公司也可能隨時增加新的通知或自行決定停止提供某些通知。
19. 您已了解並同意，由行動應用程式及網頁應用程式提供給您的任何通知可能會有延遲被攔截的情形，本公司將竭力提供及時的通知與準確的訊息。然而，我們無法保證成功通知也無法保證通知之正確性。您也同意本公司不對任何延誤、無法通知、不當通知或通知內容之任何錯誤負責，也不對您或任何第三方因通知而採取或沒有採取的行為負責。

<h4>其他</h4>20. 本公司得隨時修改本條款，若本條款有任何修改時，我們會透過公告或其他方式告知。您有義務經常檢視本條款內容之變更。若您同意使用本服務，即表示您願意受變更後之條款拘束。
21. 本條款之解釋與適用，以及與本條款有關或使用者與本公司間因智慧醫療服務而產生之爭議或糾紛，應依照中華民國法律予以處理，並以台灣台北地方法院為第一審管轄法院。
22. 如您對本條款有任何意見或疑義，請來信與我們聯繫(聯繫方式: dentco0@gmail.com )。
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" @click="close">關閉視窗</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermModal',
  props: {
    isActive: Boolean,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.content {
  white-space: pre-wrap;
}
</style>
